

  import Vue from 'vue'
  import Component from "vue-class-component";

  import {Prop, Watch} from "vue-property-decorator";
  import {IOnOffHandlers} from "bonomo/dist";
  import {namespace} from "vuex-class";
  import {IErrors} from "@/model/IErrors";
  import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";

  const imageUploaderModule = namespace("imageUploaderModule");

  const STATUS_INITIAL = 0,
      // STATUS_SELECTED = 1,
      STATUS_SAVING = 2,
      // STATUS_SUCCESS = 3,
      STATUS_FAILED = 4;

  @Component({
    components: {SimpleConfirmationDialog}
  })
  export default class ImageUploader extends Vue {

    @Prop({ default: 'image' })
    formField!: string;
    @Prop()
    endpoint!: string;
    @Prop()
    src!: string;
    @Prop()
    disabled!: boolean;
    @Prop()
    editing!: boolean;
    @Prop()
    translationPrefix!: string;
    @Prop()
    hint!: string;

    @imageUploaderModule.Getter('newImageUrl')
    newImageUrl!: IErrors;
    @imageUploaderModule.Getter('errors')
    errors!: IErrors;

    get isInitial(): boolean {
      return this.currentStatus === STATUS_INITIAL && !this.editing;
    }
    get isSelected(): boolean {
      // return this.currentStatus === STATUS_SELECTED;
      return this.currentStatus === STATUS_INITIAL && this.editing;
    }
    get isSaving(): boolean {
      return this.currentStatus === STATUS_SAVING;
    }
    get isFailed(): boolean {
      return this.currentStatus === STATUS_FAILED;
    }

    currentStatus: number = 0;
    fileToUpload: File|null = null;
    adding: boolean = false;
    loading: boolean = false;
    submitting: boolean = false;
    dialogShowing: boolean = false;
    subscribes: IOnOffHandlers = {};

    created() {
      this.subscribes = this.$ons({
        'backend.call.OK.imageUploaded': this.onOK,
        'backend.call.KO.imageUploaded': this.onKO,
      });
    }

    mounted() {
      this.reset();
    }

    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    onFilesChanged(event: any) {

      if (!event.target.files.length) {
        return;
      }

      this.$emit('update:editing', true);
      this.fileToUpload = event.target.files[0];
      this.currentStatus = STATUS_INITIAL;
      this.dialogShowing = true;

    }

    onUploadConfirmed() {
      this.dialogShowing = false;
      this.save();
    }

    onUploadCancelled() {
      this.dialogShowing = false;
      this.reset();
    }

    private reset() {
      this.$emit('update:editing', false);
      this.fileToUpload = null;
      (this.$refs.fileInputRef as any).value = null;
      this.currentStatus = STATUS_INITIAL;
    }

    private save() {

      this.$emit('update:editing', true);
      this.currentStatus = STATUS_SAVING;

      this.$store.dispatch('imageUploaderModule/uploadImage', {
        endpoint: this.endpoint,
        file: this.fileToUpload,
        translationPrefix: this.translationPrefix,
      });

    }

    private onOK() {
      if (!this.isSaving) {
        return;
      }
      this.$uiBus.emit('success', this.$t('common.uploadImage.success'));
      this.$emit('change', this.newImageUrl);
      this.$emit('update:editing', false);
      this.currentStatus = STATUS_INITIAL;
    }

    private onKO() {
      if (!this.isSaving) {
        return;
      }
      this.$emit('update:editing', false);
      this.currentStatus = STATUS_FAILED;
    }

  }

